// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/accordion","root":"accordion-m__root__Rxs8b"};